import type { Deployment } from '@/models/deployment'
import type { Image } from '@/models/image'
import type { Machine } from '@/models/machine'
import type { Snapshot } from '@/models/snapshot'

export function buildDeploymentTarget({
  saved,
  keepExisting,
  machine,
  image,
  snapshot,
  count,
}: {
  saved?: Deployment
  keepExisting: boolean
  machine?: Machine
  image?: Image
  snapshot?: Snapshot
  count: number
}) {
  // A saved target is authoritative even when its image is outside the current catalog page.
  if (keepExisting && saved) {
    return {
      resource: { ...saved.runtimeEnv.hardwareEnv.resource },
      systemEnv: { ...saved.runtimeEnv.systemEnv },
    }
  }
  if (!machine || !Number.isInteger(count) || count < 1 || Boolean(image) === Boolean(snapshot))
    return
  const sourceId = image?.id ?? snapshot?.id
  if (!sourceId || !Number.isInteger(sourceId) || sourceId < 1) return
  return {
    resource: {
      cpus: machine.unitSpec.cpuCores * count,
      gpus: (machine.unitSpec.gpuCores ?? 0) * count,
      diskGB: machine.unitSpec.diskGB * count,
      gpuName: machine.unitSpec.gpuName,
      domain: '',
      agentDomains: [machine.domains?.[0] ?? 0],
      agentDriver: 1,
      cpuName: machine.unitSpec.cpuName,
      ramMB: machine.unitSpec.ramMB * count,
      gpuRamMB: (machine.unitSpec.gpuRamMB ?? 0) * count,
      attributeTags: 64,
      machineClassTag: machine.unitSpec.classTag,
      machineCategory: machine.machineCategory,
      unitQty: count,
    },
    systemEnv: {
      fromImageId: image?.id ?? 0,
      fromSnapshotId: snapshot?.id ?? 0,
      cmd: '',
      envs: '',
      extraPorts: [] as number[],
    },
  }
}
